import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-4 lg:gap-6 px-4" }
const _hoisted_2 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_3 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_4 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_5 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_6 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_7 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_9 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_10 = {
  key: 1,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_11 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_12 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_13 = { class: "col-span-2 lg:col-span-1" }

import { 
		localesStore as _localesStore
	} from '@/store/locales'

	
	const __default__ = { name: 'BankInformation' } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		contactType: {
			type: String,
			default: ""
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	// store
	const props = __props

	const localesStore = _localesStore()
	

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('79'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::bank_name'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('82'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::bank_code'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('85'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::account_type'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('611'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::invoice_number'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('80'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::branch_name'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('83'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::account_num'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    (__props.contactType === 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_data_display, {
            label: _unref(localesStore).getLabel('86'),
            value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::kigou_num'] || '-' ,
            loading: __props.loading
          }, null, 8, ["label", "value", "loading"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('753'),
        value: _ctx.$filters.percentage(__props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::tax_percent']) || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    (__props.contactType === 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_data_display, {
            label: _unref(localesStore).getLabel('29'),
            value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::my_number'] || '-' ,
            loading: __props.loading
          }, null, 8, ["label", "value", "loading"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('81'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::branch_num'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('84'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::account_name'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_data_display, {
        label: _unref(localesStore).getLabel('230'),
        value: __props.contact?.fieldData?.['contact__CONTACTS_INFO__contactID::tax_name'] || '-' ,
        loading: __props.loading
      }, null, 8, ["label", "value", "loading"])
    ])
  ]))
}
}

})